import $ from 'jquery';
window.$ = window.jQuery = $;

import 'bootstrap';
import '@popperjs/core';
require('./plugins/lity.min');
require('./plugins/sweetalert2');

require('./plugins/jquery-ui.min');
require('./Main.js');
require('./Banner.js');
require('./Product.js');